import { useEffect } from "react";
import { useConfigurationContext } from "../root/ConfigurationContext";

/** Update all favicon link elements when configuration changes */
export const useFaviconUpdater = () => {
  const config = useConfigurationContext();

  useEffect(() => {
    if (!config.favicon) return;

    // Get the favicon URL (handle both string and object formats)
    const faviconUrl =
      typeof config.favicon === "object"
        ? (config.favicon as { src: string }).src
        : config.favicon;

    if (!faviconUrl) return;

    // Find all existing favicon link elements
    const existingLinks = document.querySelectorAll<HTMLLinkElement>(
      'link[rel="icon"], link[rel="shortcut icon"]',
    );

    if (existingLinks.length > 0) {
      // Update all existing favicon links
      existingLinks.forEach((link) => {
        if (link.href !== faviconUrl) {
          link.href = faviconUrl;
          // Remove type attribute for external URLs (let browser detect)
          if (faviconUrl.startsWith("http")) {
            link.removeAttribute("type");
          }
        }
      });
    } else {
      // Create a new favicon link if none exists
      const link = document.createElement("link");
      link.rel = "icon";
      link.href = faviconUrl;
      document.head.appendChild(link);
    }
  }, [config.favicon]);
};
